import React from 'react'


function OpenAccount() {
    return ( 
        <div className='container p-5'>
            <div className='row text-center '>
                <h3 className='mt-3'>Open a Zerodha account</h3> <br></br><br></br><br></br>
                <p style={{color: "gray"}}>Modern platforms and apps, ₹0 investments, and flat ₹20 intraday and F&O trades. <b>signup in Kite only</b></p><br></br><br></br>
                <a href="signup">
                    <button className='p-3 btn btn-primary fs-6 mb-5' style={{width: "18%", margin: "0 auto"}}>Sign up for free</button>
                </a>
            </div>
        </div>
     );
}

export default OpenAccount;